module.exports = __webpack_public_path__ + "img/Sunlei_Outstanding_Postdoctoral_Fellow.6bbf9a60.png";